import styled from 'styled-components';
import { Anchor } from '@klaviyo-mkt/gatsby-components/atoms/anchor';
import Typography from '@klaviyo-mkt/gatsby-components/atoms/typography';
import SubCategoryCard from '@klaviyo-mkt/gatsby-components/molecules/subcategory-card';
import Grid from '@klaviyo-mkt/gatsby-components/utils/grid';

export const PageWrapper = styled(Grid)`
  display: block;
`;

export const SupportRequestHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  grid-column: 1 / -1;
  margin: 2.4rem 0 1.6rem 0;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      margin: 4rem 0;
    }
  `}
`;

export const Breadcrumbs = styled.div`
  display: flex;
  font-size: 1.4rem;
  gap: 0.8rem;
  line-height: 2.0rem;
`;

export const Slash = styled.div``;

export const Breadcrumb = styled(Anchor)``;

export const CurrentBreadcrumb = styled.div``;

export const Header = styled.div`
  text-align: center;
  padding: 4rem;
`;

export const Title = styled(Typography)`
`; 

export const Text = styled(Typography)`
  padding-top: 2.4rem;
`;

export const TextLink = styled.a`
  color: ${({ theme }) => theme.colors.charcoal};
  text-underline-offset: 0.3rem;
`;

export const SubcategoryCards = styled.div`
  display: flex;
  gap: 2.4rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      align-items: stretch;
      flex-direction: row;
    }
  `}
`;

export const StyledSubCategoryCard = styled(SubCategoryCard)`
`;

export const Divider = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.sand};
  margin: 4rem auto;
`;

export const StyledForm = styled.div`
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      padding-left: 4.6rem;
      padding-right: 4.6rem;
    }
  `}
`;

export const FormContainer = styled.div`
  margin: 0 auto; 
  max-width: 60rem;
  padding-bottom: 5.6rem;
`;
